module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar navbar-fixed-top navbar-default",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "height": "80px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    staticStyle: {
      "background-color": "#367fa9"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#info'),
      expression: "'#info'"
    }],
    class: ['smoothScroll', _vm.$parent.activeMenu == 'HOME' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.$parent.activeMenu = 'HOME'
      }
    }
  }, [_vm._v("HOME")])]), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#Dashboard'),
      expression: "'#Dashboard'"
    }],
    class: ['smoothScroll', _vm.$parent.activeMenu == 'Dashboard' ? 'active' : ''],
    attrs: {
      "href": "#Dashboard"
    },
    on: {
      "click": function($event) {
        _vm.$parent.activeMenu = 'Dashboard'
      }
    }
  }, [_vm._v("DASHBOARD")])]), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#service'),
      expression: "'#service'"
    }],
    class: ['smoothScroll', _vm.$parent.activeMenu == 'SERVICE' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.$parent.activeMenu = 'SERVICE'
      }
    }
  }, [_vm._v("SERVICES")])]), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#portfolio'),
      expression: "'#portfolio'"
    }],
    class: ['smoothScroll', _vm.$parent.activeMenu == 'PROJECTS' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.$parent.activeMenu = 'PROJECTS'
      }
    }
  }, [_vm._v("PARTNERS")])]), _vm._v(" "), (0 > 1) ? _c('li', [_c('a', {
    class: ['smoothScroll', _vm.$parent.activeMenu == 'DOWNLOADS' ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.$root.goto('Download')
      }
    }
  }, [_vm._v("DOWNLOADS")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contact'),
      expression: "'#contact'"
    }],
    class: ['smoothScroll', _vm.$parent.activeMenu == 'CONTACT' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.$parent.activeMenu = 'CONTACT'
      }
    }
  }, [_vm._v("CONTACT")])]), _vm._v(" "), _c('li', [_c('a', {
    class: ['smoothScroll', _vm.$parent.activeMenu == 'DOCUMENTATION' ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.$root.goto('Guide')
      }
    }
  }, [_vm._v("DOCUMENTATION")])]), _vm._v(" "), _c('li', [_c('a', {
    class: ['smoothScroll'],
    on: {
      "click": function($event) {
        return _vm.$root.goto('Login')
      }
    }
  }, [_vm._v("LOGIN")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header",
    staticStyle: {
      "height": "100px"
    }
  }, [_c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse"
    }
  }, [_c('span', {
    staticClass: "icon icon-bar primary-bk"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon icon-bar primary-bk"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon icon-bar primary-bk"
  })]), _vm._v(" "), _c('img', {
    staticStyle: {
      "height": "100px",
      "float": "left"
    },
    attrs: {
      "src": require("../../../static/img/landing/shutterstock_464244548.jpg")
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/logo-small.png"),
      "alt": "Kirnil Technologies Logo"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-160e1a85!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/navbar.vue
// module id = 675
// module chunks = 0